export { default } from "./MultiTooltip";
